import React from 'react';
import { Edit3, Eye } from 'lucide-react';
import { CanvasMode } from '../BoardCanvas';

interface ModeToggleProps {
  mode: CanvasMode;
  onModeChange: (mode: CanvasMode) => void;
  leftOffset?: string;
}

export const ModeToggle: React.FC<ModeToggleProps> = ({ mode, onModeChange, leftOffset = '20px' }) => {
  const isEditMode = mode === 'edit';
  
  return (
    <div
      style={{
        position: 'absolute',
        top: '16px',
        right: leftOffset,
        zIndex: 1001,
      }}
    >
      <button
        onClick={() => onModeChange(mode === 'view' ? 'edit' : 'view')}
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          gap: '8px',
          padding: '8px 16px',
          border: '1px solid',
          borderColor: isEditMode ? 'rgb(34, 197, 94)' : 'rgb(59, 130, 246)',
          borderRadius: '8px',
          backgroundColor: 'white',
          color: isEditMode ? 'rgb(22, 163, 74)' : 'rgb(37, 99, 235)',
          fontSize: '14px',
          fontWeight: '500',
          cursor: 'pointer',
          boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.05)',
          transition: 'all 0.15s cubic-bezier(0.4, 0, 0.2, 1)',
          fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
        }}
       
        title={mode === 'view' ? 'Switch to Edit Mode' : 'Switch to View Mode'}
      >
        {isEditMode ? (
          <>
            <Eye size={16} strokeWidth={2} />
            <span>View</span>
          </>
        ) : (
          <>
            <Edit3 size={16} strokeWidth={2} />
            <span>Edit</span>
          </>
        )}
      </button>
    </div>
  );
};
